export type Navigation = {
  name: string;
  path: string;
};

export const USER_MENU: Navigation[] = [
  { name: "Dashboard", path: "/my-account" },
  { name: "Orders", path: "/my-account/orders" },
  { name: "Addresses", path: "/my-account/edit-address" },
  { name: "Account details", path: "/my-account/edit-account" },
  { name: "Logout", path: "/my-account/customer-logout" },
];
